/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_list = /** @type {(inputs: {}) => string} */ () => {
	return `Seznam`
};

const da_list = /** @type {(inputs: {}) => string} */ () => {
	return `Liste`
};

const de_list = /** @type {(inputs: {}) => string} */ () => {
	return `Liste`
};

const en_list = /** @type {(inputs: {}) => string} */ () => {
	return `List`
};

const es_list = /** @type {(inputs: {}) => string} */ () => {
	return `Lista`
};

const fr_list = /** @type {(inputs: {}) => string} */ () => {
	return `Liste`
};

const hu_list = /** @type {(inputs: {}) => string} */ () => {
	return `Lista`
};

const it_list = /** @type {(inputs: {}) => string} */ () => {
	return `Lista`
};

const nl_list = /** @type {(inputs: {}) => string} */ () => {
	return `Lijst`
};

const pl_list = /** @type {(inputs: {}) => string} */ () => {
	return `Lista`
};

const pt_list = /** @type {(inputs: {}) => string} */ () => {
	return `Lista`
};

const sv_list = /** @type {(inputs: {}) => string} */ () => {
	return `Lista`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const list = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.list(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("list", locale)
	if (locale === "cs") return cs_list(inputs)
	if (locale === "da") return da_list(inputs)
	if (locale === "de") return de_list(inputs)
	if (locale === "en") return en_list(inputs)
	if (locale === "es") return es_list(inputs)
	if (locale === "fr") return fr_list(inputs)
	if (locale === "hu") return hu_list(inputs)
	if (locale === "it") return it_list(inputs)
	if (locale === "nl") return nl_list(inputs)
	if (locale === "pl") return pl_list(inputs)
	if (locale === "pt") return pt_list(inputs)
	return sv_list(inputs)
};